import Resource from './Resource';

export default class AvailableClasses extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = !!routeParams.setting ? 'interactive-schedules/:setting' : 'interactive-schedules';

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
